import React, {Component} from 'react';
import {autobind} from 'core-decorators';
import { Modal } from 'antd-mobile';
import tools from '../../utils/tools';
import DropdownButton from '../DropdownButton/DropdownButton';
import shallowCompare from 'react-addons-shallow-compare';
import './ReorderBar.less';

const preventEvent = (event) => {
    if (event) {
        event.preventDefault();
        event.stopImmediatePropagation && event.stopImmediatePropagation();
        event.stopPropagation();
    }
};

class ReorderBar extends Component {

    constructor(props, context) {
      super(props, context);
      const {defaultStroValue = 0,itemValues,reportName} = props;
      //如果有报表名字  从本地缓存中获取
      if(reportName){
        let storInfo = tools.getCache('ReorderBar',reportName);
        if(storInfo){
          this.state={
            open: false,
            storTitle: storInfo.storTitle,
            storValue: storInfo.storValue
          }
          return;
        }
      }

      itemValues.forEach((itemValue,index)=>{
        if(itemValue.value==defaultStroValue){
          this.state = {
            open: false,
            storTitle: itemValue.title,
            storValue: itemValue.value
          };
        }
      });
    }

    shouldComponentUpdate(nextProps, nextState) {
      return shallowCompare(this, nextProps, nextState);
    }

    styles() {
      return {
        iconButton: {
          minWidth: '30px',
          height: '30px'
        }
      }
    }

    @autobind
    handleCalendarDown(event,dateRange) {
      preventEvent(event);
      let open = this.state.open;
      this.setState({
        open: true,
        anchorEl: event.currentTarget
      });
    }

    //日期按钮组点击处理
    @autobind
    handleRequestClose(storValue, storTitle, event) {

      if(storValue == 'clickAway'){
        this.setState({
          open: false
        });
        return;
      }

      preventEvent(event);

      this.setState({
        open: false,
        storTitle: storTitle,
        storValue: storValue
      });
      this._handleStorClick(storTitle,storValue);
    }

    renderItems() {
      const itemValues = this.props.itemValues;
      return itemValues.map((item, index) => {
        item.isChoosed = item.value == this.state.storValue;
        return  <DropdownButton title={item.title} value={item.value} index={index} isChoosed={item.isChoosed} choose={this.handleRequestClose.bind(this, item.value, item.title,item.name)}/>;
      });
    }



    //本地记忆+点击事件触发
    _handleStorClick(storTitle,storValue){
      const {storClick,reportName} = this.props;
      //本地记忆
      if(reportName){
        let cacheItem = {storTitle:storTitle,storValue:storValue};
        tools.putCache('ReorderBar',reportName,cacheItem);
      }
      if(storClick){
        let storParam = {storTitle:storTitle,storValue:storValue};
        storClick(storParam);
      }
    }

    render(e) {
        const styles = this.styles();
        const {calendarBtnCls} = this.props;
        return (
          <div className={calendarBtnCls}>
            <div onClick={this.handleCalendarDown}><span>排序：</span><span style = {{marginRight:'0.2rem'}}>{this.state.storTitle}</span><i className="chanjet-icon-Arrow-bottom icon "></i></div>
            <Modal
                popup
                wrapClassName ='reorderBar-modal-wrap'
                visible={this.state.open}
                onClose = {this.handleRequestClose}
                animationType="slide-down">
                <div className="dropDownGroup">
                  {this.renderItems()}
                </div>
              </Modal>
            {this.state.open && <div className="sort-mask"></div>}
          </div>
        );
    }
}

export default ReorderBar;
